import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthWebService } from 'app/services/authweb.service';
import { ScannerService } from 'app/services/scanner.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { VehicleTypeService } from 'app/services/vehicle-type.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-scanner',
  templateUrl: './add-scanner.component.html',
  styleUrls: ['./add-scanner.component.css']
})
export class AddScannerComponent implements OnInit {
  form;
  vType: any = {};
  sub: any;
  lblHeading = '';
  btnActionLabel = '';
  isEdit: boolean;  
  isDup = false; 
  selectedDisplay = 3;
  message = null;
  now = new Date();
  audit = { created: '', updated: '' };
  user = { LastName: '' };
 
  
  public isLoading = false;

  constructor(private service: ScannerService, private authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute,
     public utility: UtilityServiceService,private toastr:ToastrService) { }

  ngOnInit() {

    this.initForm();
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    this.sub = this.route.params.subscribe(params => {
      if (this.router.url.indexOf('edit') != -1) {
        this.isEdit = true;
        this.lblHeading = 'Edit Scanner';
        this.btnActionLabel = 'Update';
        const id = +params['id'];
        this.isLoading = true;
        this.service.getScannerByID(id).subscribe(result => {
          console.log(result)
          this.vType = result;
          this.isLoading = false;
          (<UntypedFormGroup>this.form)
            .setValue({
              id: this.vType.id
              , device_id: this.vType.device_id
              , scanner_alias: this.vType.scanner_alias
              , scanner_ip_address: this.vType.scanner_ip_address
              ,date_modified:this.vType.date_created
              ,user_created:this.vType.user_created
              ,user_modified:this.vType.user_created
              ,date_created:this.vType.date_created
              ,status_id:this.vType.status_id
              ,pc_ip_address:this.vType.pc_ip_address
              ,scanner_status:this.vType.status_id


            }, { onlySelf: true });
          this.audit = this.utility.setAuditAttributes(this.vType.date_created, this.vType.user_created, this.vType.date_created, this.vType.user_modified);
        });
      } else {
        this.isEdit = false;
        this.lblHeading = 'Add New';
        this.btnActionLabel = 'Save';
        this.audit = this.utility.setAuditAttributes(this.now, this.user.LastName, this.now, this.user.LastName); 
      }
    });
  }


  initForm() {
    this.form = new UntypedFormGroup({
      id: new UntypedFormControl()
      , device_id: new UntypedFormControl(this.vType.device_id)
      , scanner_alias: new UntypedFormControl(this.vType.scanner_alias)
      , scanner_ip_address: new UntypedFormControl(this.vType.scanner_ip_address)
      , date_created: new UntypedFormControl()
      , date_modified: new UntypedFormControl()
      , user_created: new UntypedFormControl()
      , user_modified: new UntypedFormControl()
      ,status_id: new UntypedFormControl()
      , scanner_status: new UntypedFormControl(this.vType.scanner_id)
      ,pc_ip_address: new UntypedFormControl(this.vType.pc_ip_address)
    });
    this.form.patchValue(this.utility.defaults);

  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit(obj: any) {    
    this.vType = obj;
    this.vType.status_id = this.form.controls['scanner_status'].value;
    this.message = (this.isEdit) ? "Updating Scanner..." : "Adding a new Scanner...";
    if (this.isEdit) {
      this.vType.date_modified = new Date().toLocaleString();
      this.vType.user_modified = this.user.LastName;
      this.isLoading = true;
      //console.log(JSON.stringify(obj));
      this.service.update(this.vType).subscribe(result => {
        this.vType = result;
        this.isLoading = false;
        //this.dialogService.addDialog(AlertComponent, { title: 'Update Scanner', message: `Scanner ${this.vType.device_id} updated succesfully.`, bold: `${this.vType.device_id}` });
        this.toastr.success(`Scanner ${this.vType.device_id} updated succesfully.`,'Update Scanner');
        this.navigate();
      }, error => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: `Update Scanner`, message: `Failed to update Scanner with ${this.vType.device_id}.Please contact the system administrator if the problem persists.`, bold: `${this.vType.device_id}` });
        this.toastr.error(`Failed to update Scanner with ${this.vType.device_id}.Please contact the system administrator if the problem persists.`,'Update Scanner');
      });
    } else {
      this.vType.date_modified = this.vType.date_created = new Date().toLocaleString();
      this.vType.user_modified = this.vType.user_created = this.user.LastName;

      this.isLoading = true;
      //console.log(JSON.parse(JSON.stringify(obj)));
      console.dir(this.vType);
      this.service.add(this.vType).subscribe(result => {
        this.vType = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'New Scanner', message: `New Scanner ${this.vType.device_id} added successfully.`, bold: `${this.vType.device_id}` });
        this.toastr.success(`New Scanner ${this.vType.device_id} added successfully.`,'New Scanner');
        this.navigate();
      }, error => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: `New Scanner`, message: `Failed to add New Scanner with ${this.vType.device_id}.Please contact the system administrator if the problem persists.`, bold: `${this.vType.device_id}` });
        this.toastr.error(`Failed to add New Scanner with ${this.vType.device_id}.Please contact the system administrator if the problem persists.`,'New Scanner');
      });
    }
  }

  navigate() {
    this.router.navigateByUrl('/scanner/list');
  }

  onDuplicates(control) {


  }


  
  onChangeValue() {
    
  }

  onSelectChange() {

  }
  
}
